export const blockIconsHouseholdHighlightNew = (
	<span className='material-symbols-outlined'>highlight</span>
);
